export enum Direction {
  Up = "up",
  Down = "down",
  Left = "left",
  Right = "right",
}
